import { Dispatch, SetStateAction, useCallback } from 'react'
import { ScheduleType } from 'types/schedule'
import { parseHoursToDeadline } from 'lib/helper'
import { FirebaseDocRefType } from 'firebase/index'

const useHandleHoursToDeadline = (
  setSchedules: Dispatch<SetStateAction<ScheduleType[]>>
): ((dateToDeadline: string, timeToDeadline: string, scheduleRef?: FirebaseDocRefType) => void) => {
  return useCallback(
    (dateToDeadline: string, timeToDeadline: string, scheduleRef?: FirebaseDocRefType) => {
      setSchedules((prevState) => {
        const nextState = prevState
        const scheduleIndex = prevState.findIndex((prevState) => prevState.schedule_ref?.id === scheduleRef?.id)
        if (scheduleIndex === -1) return prevState
        nextState[scheduleIndex].hours_to_deadline = parseHoursToDeadline(dateToDeadline, timeToDeadline)
        return [...nextState]
      })
    },
    [setSchedules]
  )
}

export default useHandleHoursToDeadline
